import React, { createContext, useContext } from "react";
//Limitless imports
import { useLogging } from "./DevLoggingHook"; // Set the default state values for each context

export var DevLogging = createContext({});
export var DevLoggingProvider = function DevLoggingProvider(_ref) {
  var reactotron = _ref.reactotron,
      children = _ref.children;
  var hook = useLogging(reactotron);
  return /*#__PURE__*/React.createElement(DevLogging.Provider, {
    value: hook
  }, children);
};
export var useDevLogging = function useDevLogging() {
  return useContext(DevLogging);
};